import { FormControl, OutlinedInput, InputAdornment, FormHelperText } from "@mui/material";
import { useCallback, useEffect, useState } from "react";

const RequestedAmount = ({ page, setPage, formData, setFormData }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const onRequestedAmountChange = (e) => {
        if (e.target.value.length > 6) {
            e.preventDefault();
        } else {
            setFormData({ ...formData, requestedAmount: parseInt(e.target.value, 10) });
        }
        setErrorMessage(null);
    }

    const updateFormData = useCallback(() => {
        setFormData(formData);
    }, [formData, setFormData]);

    useEffect(() => {
        updateFormData();
    }, [updateFormData]);

    useEffect(() => {
        setErrorMessage(null);
    }, [formData.lang]);

    const preventNonPositiveInteger = (e) => {
        if (e.key === "e" || e.key === "." || e.code === 'Minus' || e.code === 'ArrowUp' || e.code === 'ArrowDown') {
            e.preventDefault();
        }
    };
    const preventPaste = (e) => {
        e.preventDefault();
    };

    return (
        <div className="card">
            <div className="card-div">
                <div className="textfield-label">{formData.lang === "fr" ? "Combien voulez-vous emprunter?" : "How much are you looking for?"}</div>
                <FormControl fullWidth>
                    <OutlinedInput
                        type="number"
                        startAdornment={
                            <div className="custom-start-adornment-div">
                                <InputAdornment style={{ marginLeft: 10 }} position="start">$</InputAdornment>
                            </div>
                        }
                        endAdornment={
                            <div className="custom-end-adornment-div">
                                <InputAdornment style={{ marginRight: 10 }} position="end">.00</InputAdornment>
                            </div>
                        }
                        value={formData.requestedAmount}
                        onPaste={preventPaste}
                        onKeyDown={preventNonPositiveInteger}
                        onWheel={(e) => e.target.blur()}
                        onChange={onRequestedAmountChange}
                    />
                    <FormHelperText style={{ color: "red" }}>{errorMessage}</FormHelperText>
                </FormControl>
                <div>
                    <button className="nav-button"
                        onClick={() => {
                            if (formData.requestedAmount >= 100) {

                                window.dataLayer.push({'event': 'loan_step2', 'loanEvent': 'step2', 'loanEventID': 3});
                                // quebec only
                                // window.dataLayer.push({'event': 'loan_step2q', 'loanEvent': 'step2q', 'loanEventID': '3q'});

                                setPage(page + 1);
                            } else if (formData.requestedAmount === "") {
                                setErrorMessage(formData.lang === "fr" ? "Veuillez saisir le montant demandé" : "Please enter your requested amount");
                            } else if (formData.requestedAmount < 100) {
                                setErrorMessage(formData.lang === "fr" ? "Veuillez entrer un montant supérieur à 100 $" : "Please enter an amount greater than $100");
                            } else {
                                setErrorMessage(formData.lang === "fr" ? "Veuillez saisir le montant demandé" : "Please enter your requested amount");
                            }
                        }}>
                        {formData.lang === "fr" ? "Suivant" : "Next"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default RequestedAmount;